module.exports = __webpack_public_path__ + "media/images/premium/premium-card-po-rb-938c653418417389c5bb22cfcff1bcd8.svg";